export const SET_USER_INFO = 'SET_USER_INFO';
export const SET_USER_LANG = 'SET_USER_LANG';
export const SET_IS_LOADING = 'SET_IS_LOADING';